var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CRUDPage',{attrs:{"searchSchema":_vm.searchSchema,"resultHeaders":_vm.resultHeaders,"resource":"holiday","title":"祝日マスタ一覧","schemaName":"Holiday"}})
}
var staticRenderFns = []

export { render, staticRenderFns }